import {keepPreviousData, useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpPreviewRecipients} from '@/features/mailer/http/mailer.http'
import {MailerRecipients} from '@/features/mailer/types'

/**
 * Live dry-run of the recipients selection (POST /mailer/recipients/preview).
 * Pass `null` while no category is selected: the BE responds 400
 * (mailer-no-recipient-groups) on an empty recipients object, so the query
 * stays disabled. `keepPreviousData` avoids counter flickering while typing.
 */
export const useRecipientsPreview = (recipients: MailerRecipients | null) =>
    useQuery({
        queryKey: [QUERY_KEYS.MAILER_RECIPIENTS_PREVIEW, recipients],
        // React Query aborts the signal when the key changes: superseded
        // previews are cancelled instead of racing the latest one.
        queryFn: ({signal}) => httpPreviewRecipients(recipients as MailerRecipients, signal),
        enabled: recipients !== null && (!!recipients.patients || !!recipients.consultants),
        placeholderData: keepPreviousData,
        staleTime: 0
    })
